import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { store } from '../stores/store'
import { useRunState } from './provider/useRunState'

/**
 * Mirrors `runState.levelCompleteCardAnimationComplete` onto `store.parentsLandingShowUi`
 * while parents landing is active, so `ParentsLandingScreen` (outside `RunStateProvider`)
 * can match `EndScreen` / `GameEnd` gating.
 */
export const ParentsLandingUiSync = observer(function ParentsLandingUiSync() {
    const runState = useRunState()
    const landingActive = store.parentsCardLandingActive
    const animationComplete = runState.levelCompleteCardAnimationComplete

    useEffect(() => {
        if (!landingActive) {
            store.setParentsLandingShowUi(false)
            return
        }
        store.setParentsLandingShowUi(animationComplete)
    }, [landingActive, animationComplete])

    return null
})
